import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

const DigestReadyBadge = ({ onClear }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = () => {
    // If already on a /digest page, refresh. Else, navigate to /digest.
    if (location.pathname.startsWith("/digest")) {
      window.location.reload();
    } else {
      navigate("/digest");
    }
    if (typeof onClear === "function") {
      onClear();
    }
  };

  const isOnDigestPage = location.pathname.startsWith("/digest");

  return (
    <div
      className="fixed top-20 left-6 z-50 cursor-pointer px-6 py-3 bg-green-600 text-white rounded-full shadow-lg font-semibold transition hover:bg-green-700"
      style={{ minWidth: 230, textAlign: "center" }}
      onClick={handleClick}
      role="button"
      aria-label={isOnDigestPage ? "Refresh Digest" : "Go to Digest"}
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") handleClick();
      }}
    >
      <span role="img" aria-label="mail" className="mr-2">
        📬
      </span>
      Your Digest is ready!
      <span className="ml-3 text-sm underline">
        {isOnDigestPage ? "Refresh" : "View now"}
      </span>
    </div>
  );
};

export default DigestReadyBadge;
